import authReducer from "./auth/slice/auth";
import userReducer from "./users/slice/user-slice";
import roleReducer from "./roles/slice/role-slice";
import accessPointReducer from "./access-points/slice/access-point-slice";
import nodesReducer from "./nodes/slice/nodes-slice";
import temperatureReducer from "./temperature/temperature-slice";
import nodeLogReducer from "./nodes/slice/node-log-slice";
import alarmNotificationsReducer from "./alarm-notifications/slice/alarm-notifications-slice";
import alarmCausesReducer from "./alarm-causes/slice/alarm-causes-slice";
export const featureReducers = {
    auth: authReducer,
    user: userReducer,
    role: roleReducer,
    accessPoint: accessPointReducer,
    nodes: nodesReducer,
    temperature: temperatureReducer,
    nodeLog: nodeLogReducer,
    alarmNotifications: alarmNotificationsReducer,
    alarmCauses: alarmCausesReducer,
};
